import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';

export const MeiliSearchClient = instantMeiliSearch(
  process.env.REACT_APP_MEILI_HOST as string,
  process.env.REACT_APP_MEILI_PUBLIC_KEY
);
